










































































































































import { Component, Vue } from 'vue-property-decorator'

import ElsaButton from '@/components/button/button.vue'
import ErikoistuvaDetails from '@/components/erikoistuva-details/erikoistuva-details.vue'
import ElsaFormGroup from '@/components/form-group/form-group.vue'
import KoejaksonVaiheHyvaksynnat from '@/components/koejakson-vaiheet/koejakson-vaihe-hyvaksynnat.vue'
import KoulutuspaikanArvioijat from '@/components/koejakson-vaiheet/koulutuspaikan-arvioijat.vue'
import ElsaConfirmationModal from '@/components/modal/confirmation-modal.vue'
import ElsaReturnToSenderModal from '@/components/modal/return-to-sender-modal.vue'
import store from '@/store'
import {
  KehittamistoimenpiteetLomake,
  Koejakso,
  KoejaksonVaiheHyvaksyja,
  KoejaksonVaiheHyvaksynta,
  KoejaksonVaiheButtonStates
} from '@/types'
import { LomakeTilat } from '@/utils/constants'
import * as hyvaksynnatHelper from '@/utils/koejaksonVaiheHyvaksyntaMapper'
import { toastFail, toastSuccess } from '@/utils/toast'

@Component({
  components: {
    ErikoistuvaDetails,
    ElsaFormGroup,
    ElsaButton,
    ElsaConfirmationModal,
    ElsaReturnToSenderModal,
    KoulutuspaikanArvioijat,
    KoejaksonVaiheHyvaksynnat
  }
})
export default class ErikoistuvaArviointilomakeKehittamistoimenpiteet extends Vue {
  $refs!: {
    koulutuspaikanArvioijat: KoulutuspaikanArvioijat
  }
  items = [
    {
      text: this.$t('etusivu'),
      to: { name: 'etusivu' }
    },
    {
      text: this.$t('koejakso'),
      to: { name: 'koejakso' }
    },
    {
      text: this.$t('koejakson-kehittamistoimenpiteet'),
      active: true
    }
  ]

  loading = true

  buttonStates: KoejaksonVaiheButtonStates = {
    primaryButtonLoading: false,
    secondaryButtonLoading: false
  }

  koejaksonVaihe = (this.$t('kehittamistoimenpiteiden-arviointi') as string).toLowerCase()

  kehittamistoimenpiteetLomake: KehittamistoimenpiteetLomake = {
    erikoistuvanKuittausaika: undefined,
    erikoistuvanErikoisala: '',
    erikoistuvanNimi: '',
    erikoistuvanOpiskelijatunnus: '',
    erikoistuvanYliopisto: '',
    id: null,
    kehittamistoimenpiteetRiittavat: null,
    korjausehdotus: '',
    lahiesimies: {
      id: null,
      kayttajaUserId: null,
      kuittausaika: '',
      nimi: '',
      nimike: null,
      sopimusHyvaksytty: false
    },
    lahikouluttaja: {
      id: null,
      kayttajaUserId: null,
      kuittausaika: '',
      nimi: '',
      nimike: null,
      sopimusHyvaksytty: false
    },
    muokkauspaiva: '',
    kehittamistoimenpideKategoriat: [],
    muuKategoria: null,
    kehittamistoimenpiteetKuvaus: null
  }

  get account() {
    return store.getters['auth/account']
  }

  get kouluttajat() {
    return store.getters['erikoistuva/kouluttajatJaVastuuhenkilot'] || []
  }

  get editable() {
    if (this.account.impersonated) {
      return false
    }
    return this.koejaksoData.kehittamistoimenpiteidenTila === LomakeTilat.UUSI
  }

  get deletable() {
    return this.koejaksoData.kehittamistoimenpiteidenTila === LomakeTilat.ODOTTAA_HYVAKSYNTAA
  }

  get acceptedByEveryone() {
    return this.koejaksoData.kehittamistoimenpiteidenTila == LomakeTilat.HYVAKSYTTY
  }

  get waitingForKouluttaja() {
    return (
      this.koejaksoData.kehittamistoimenpiteidenTila === LomakeTilat.ODOTTAA_HYVAKSYNTAA ||
      this.koejaksoData.kehittamistoimenpiteidenTila === LomakeTilat.ODOTTAA_ESIMIEHEN_HYVAKSYNTAA
    )
  }

  get koejaksoData(): Koejakso {
    return store.getters['erikoistuva/koejakso']
  }

  setKoejaksoData() {
    if (this.koejaksoData.kehittamistoimenpiteet) {
      this.kehittamistoimenpiteetLomake = this.koejaksoData.kehittamistoimenpiteet
    }
    this.kehittamistoimenpiteetLomake.erikoistuvanNimi = `${this.account.firstName} ${this.account.lastName}`
    this.kehittamistoimenpiteetLomake.erikoistuvanOpiskelijatunnus =
      this.account.erikoistuvaLaakari.opiskelijatunnus
    this.kehittamistoimenpiteetLomake.erikoistuvanErikoisala =
      this.account.erikoistuvaLaakari.erikoisalaNimi
    this.kehittamistoimenpiteetLomake.erikoistuvanYliopisto =
      this.account.erikoistuvaLaakari.yliopisto
  }

  get hyvaksynnat(): KoejaksonVaiheHyvaksynta[] {
    const hyvaksyntaLahikouluttaja = hyvaksynnatHelper.mapHyvaksyntaLahikouluttaja(
      this,
      this.kehittamistoimenpiteetLomake.lahikouluttaja
    )
    const hyvaksyntaLahiesimies = hyvaksynnatHelper.mapHyvaksyntaLahiesimies(
      this,
      this.kehittamistoimenpiteetLomake.lahiesimies
    )
    const hyvaksyntaErikoistuva = hyvaksynnatHelper.mapHyvaksyntaErikoistuva(
      this,
      this.kehittamistoimenpiteetLomake.erikoistuvanNimi,
      this.kehittamistoimenpiteetLomake.erikoistuvanKuittausaika
    )

    return [hyvaksyntaLahikouluttaja, hyvaksyntaLahiesimies, hyvaksyntaErikoistuva].filter(
      (a): a is KoejaksonVaiheHyvaksynta => a !== null
    )
  }

  hideModal(id: string) {
    return this.$bvModal.hide(id)
  }

  onValidateAndConfirm(modalId: string) {
    if (
      this.$refs.koulutuspaikanArvioijat &&
      !this.$refs.koulutuspaikanArvioijat.validateForm()
    ) {
      return
    }
    return this.$bvModal.show(modalId)
  }

  onLahikouluttajaSelect(lahikouluttaja: KoejaksonVaiheHyvaksyja) {
    this.kehittamistoimenpiteetLomake.lahikouluttaja = lahikouluttaja
  }

  onLahiesimiesSelect(lahiesimies: KoejaksonVaiheHyvaksyja) {
    this.kehittamistoimenpiteetLomake.lahiesimies = lahiesimies
  }

  async onSend() {
    try {
      this.buttonStates.primaryButtonLoading = true
      await store.dispatch(
        'erikoistuva/postKehittamistoimenpiteet',
        this.kehittamistoimenpiteetLomake
      )
      this.buttonStates.primaryButtonLoading = false
      toastSuccess(this, this.$t('kehittamistoimenpiteet-arviointipyynnon-lahetys-onnistui'))
      this.setKoejaksoData()
    } catch {
      toastFail(this, this.$t('kehittamistoimenpiteet-arviointipyynnon-lahetys-epaonnistui'))
    }
  }

  async onFormDelete() {
    try {
      this.buttonStates.primaryButtonLoading = true
      await store.dispatch(
        'erikoistuva/deleteKehittamistoimenpiteet',
        this.kehittamistoimenpiteetLomake
      )
      this.buttonStates.primaryButtonLoading = false
      toastSuccess(this, this.$t('lomake-tyhjennetty-onnistuneesti'))
      this.kehittamistoimenpiteetLomake.id = null
    } catch {
      toastFail(this, this.$t('lomakkeen-tyhjennys-epaonnistui'))
    }
  }

  async mounted() {
    if (!this.koejaksoData) {
      await store.dispatch('erikoistuva/getKoejakso')
    }
    await store.dispatch('erikoistuva/getKouluttajatJaVastuuhenkilot')
    this.setKoejaksoData()
    this.loading = false
  }
}
